import React from "react"
import {
  MenuScroller,
  MenuTitleH3,
} from "../reusable/menu-slider/menu-slider.styles"
import MenuSlider from "../reusable/menu-slider/menu-slider"
import PropTypes from "prop-types"
import Video from "../reusable/video"

function TripTypeExplanationMenuSlider({ isOpen, setIsOpen, type }) {
  return (
    <MenuSlider isOpen={isOpen} setIsOpen={setIsOpen}>
      <Video
        url={"https://www.youtube.com/embed/MwzpsfdUotg"}
        alt={"Trip Type video"}
      />
      <MenuScroller>
        {(type?.includes("Private") || type?.includes("Scheduled")) &&
          type?.includes("Self-guided") && (
            <p>
              <MenuTitleH3>Self-Guided Tours </MenuTitleH3>
              Self-guided tours provide the freedom and flexibility to discover
              the world at your own pace. Our team handles the logistics,
              crafting an itinerary filled with hidden gems and must-see spots,
              while also providing detailed route notes, GPS guidance, and 24/7
              support. Self-guided tours are perfect if you crave spontaneity or
              enjoy adventuring with friends and family on your own terms. It’s
              your journey—exactly how you want it.
            </p>
          )}

        {type?.includes("Guided") && type?.includes("Private") && (
          <p>
            <MenuTitleH3>Private Guided Tours </MenuTitleH3>
            Private guided tours are organized for your party only. You will
            have the freedom to personalize every detail of your trip, with the
            added benefit of a seasoned guide to bring each place to life with
            local knowledge. Private guided tours are ideal for families,
            couples, or friends looking for an exclusive and immersive travel
            experience.
          </p>
        )}
        {type?.includes("Partially guided") && type?.includes("Private") && (
          <p>
            <MenuTitleH3>Partially guided Tours </MenuTitleH3>
            Partially Guided Tours Partially guided tours offer a blend of
            expert guidance and self-directed exploration. Enjoy the convenience
            of a guide during key segments of your trip, combined with free time
            to wander at your leisure. It’s the ideal option for travelers
            seeking a mix of structure and freedom.
          </p>
        )}
        {type?.includes("Partially-guided") && type?.includes("Scheduled") && (
          <p>
            <MenuTitleH3>Small Group Tours </MenuTitleH3>
            Small group tours are perfect for travellers who love meeting new
            people, enjoy structured adventures, and want a stress-free
            experience. These scheduled, guided tours offer a welcoming
            environment and bring together a handful of like-minded travelers to
            share an unforgettable journey.
          </p>
        )}
      </MenuScroller>
    </MenuSlider>
  )
}

export default TripTypeExplanationMenuSlider

TripTypeExplanationMenuSlider.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  type: PropTypes.string,
}
